import BaseDialog from "@/components/BaseDialog";

// 工单管理-待指派 撤回
export function withdrawModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./withdrawModal.vue'),
        options: {
            width: '600px',
            title: '温馨提示',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 工单管理- 结单
export function settleModel({ props, cbs, on }) {
    return new BaseDialog({
        component: ()=>import('./settleModel.vue'),
        options: {
            width: '600px',
            title: '结单',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        on,
    })
}

// 工单管理- 拒绝素材
export function rejectModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./rejectModal.vue'),
        options: {
            width: '600px',
            title: '拒绝素材',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

export function resultModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./resultModal.vue'),
        options: {
            width: '600px',
            title: '通过素材',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

export function resultOnceModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./resultOnceModal.vue'),
        options: {
            width: '600px',
            title: '通过素材',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 工单管理 剔除不可下载的素材
export function filterNullDownModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./filterNullDown.vue'),
        options: {
            width: '600px',
            title: '下载素材为空',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 工单管理 剔除不可拒绝的素材
export function filterNullRejectModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./filterNullReject.vue'),
        options: {
            width: '600px',
            title: '温馨提醒',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 工单管理- 批量下载
export function downLoadModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./downLoadModal.vue'),
        options: {
            width: '600px',
            title: props.title || '批量下载',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

export function tagEditModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./tagEditModal.vue'),
        options: {
            width: '600px',
            title: `工单标签 【共${props.selectList.length}个工单】`,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        slots: {
            title: (h)=>[
                h('span',{ class: 'text-color-normal' },`工单标签`),
                h('span',{ class: 'text-color-gray pl10' },`共${props.selectList.length}个工单`)
            ],
        }
    })
}

// 任务管理 - 修改落点时间（单行/批量共用·2026-09-14 workOrder_v3）
export function deliveryEditModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./deliveryEditModal.vue'),
        options: {
            width: '600px',
            title: `修改落点时间 【共${props.selectList.length}个工单】`,
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
        slots: {
            title: (h)=>[
                h('span',{ class: 'text-color-normal' },`修改落点时间`),
                h('span',{ class: 'text-color-gray pl10' },`共${props.selectList.length}个工单`)
            ],
        }
    })
}
